<template>
    <div class="book-a-tutor">
      <v-hover
        v-slot:default="{ hover }"
        open-delay="100"
      >
        <v-btn
          :style="{'color':primary_color}"
          class="mx-2 book-button"
          rounded
          fab 
          fixed 
          bottom 
          right 
          large
          @click="openTutorListModal"
        >
      
        <v-icon class="mx-2" large>mdi-account-tie-voice</v-icon>
        <v-expand-x-transition>
        <span v-if="hover" class="mx-2 ml-2">{{ buttonName | translate }}</span>
        </v-expand-x-transition>
        </v-btn>
      </v-hover>

      

    <v-dialog v-if="!loadingdata" v-model="tutorDialog" persistent max-width="1000">
      <v-card v-if="tutorproducts.length>0" class="tutor-container">
        <v-card-title class="headline">{{ 'Tutor Products Available' | translate }} <v-spacer></v-spacer> <v-btn color="primary darken-1" text @click="tutorDialog = false">{{ 'Close' | translate }}</v-btn></v-card-title>
             <v-row align="center" no-gutters>
                <v-col cols="12" class="tutor-product-box">
                        <v-card elevation="2" v-for="(data) in tutorproducts" :key="data.tutor_product_id" class="tutor-element">
                            <v-row no-gutters>
                                <v-col cols="12" md="2" class="image-box">
                                    <v-img
                                        :src="storage_url+data.tutor_product_pic"
                                        aspect-ratio="1"
                                        class="tutor-image grey lighten-2"
                                    ></v-img>
                                </v-col>

                                <v-col cols="12" md="8">
                                        <div class="title"> {{ data.tutor_product_name }} </div>
                                        <div class="sub-title"> {{data.tutor_product_description}} </div>
                                </v-col>

                                <v-col cols="12" md="2">
                                  <div class="text-subtitle-1">{{ data.plan.product_amount }} <v-icon small> mdi-currency-{{data.plan.currency}}</v-icon></div>
                                  <div class="sub-title">
                                      <v-card-actions>
                                          <v-btn
                                              small
                                            :color="primary_color"
                                            style='color:white;'
                                              @click="openbooking(data)"
                                          >{{'Book'| translate}}</v-btn>
                                      </v-card-actions>
                                   </div>    
                                </v-col> 
                            </v-row>
                        </v-card>
                </v-col>
             </v-row>
      </v-card>
      <v-card v-else>
           <v-card-title> {{ 'No Tutor Products to display' | translate }} <v-spacer></v-spacer> <v-btn color="primary darken-1" text @click="tutorDialog = false">{{ 'Close' | translate }}</v-btn></v-card-title>
      </v-card>
    </v-dialog>

     <v-dialog v-if="!loadingdata" v-model="bookingDialog" persistent max-width="1000">
      <v-card >
        <v-card-title class="headline">{{ 'Order Purchase Confirmation' | translate }}<v-spacer></v-spacer> <v-btn color="primary darken-1" text @click="bookingDialog = false">{{ 'Close' | translate }}</v-btn></v-card-title>
        <v-card-title> {{this.tutorProduct.tutor_product_name}} </v-card-title>
        <v-card-text>  {{this.tutorProduct.tutor_product_description}} </v-card-text>
          <v-card elevation="0">
            <v-row align="center" justify="space-around">
              <v-col cols="12" sm="7" lg="5">
                  <v-card-title v-if="card_present"> {{'Pay securely using' | translate}} </v-card-title>
                  <v-card-title v-if="!card_present" :class=" no_card_notification ? 'no_card_notification': ''"> {{'Add a Card' | translate}} </v-card-title>
                    <v-row>
                      <v-col v-for="(v, k) in stripeallcards" :key="k" cols="12" sm="6">
                        <v-card v-if="v.is_default" class="mx-auto" max-width="344">
                          <v-card-text>
                            <div>xxxxxxxxxxxx{{v.card_last_four}}</div>

                            <p class="display-1 text--primary">{{v.card_brand}}</p>
                            <div class="text--primary">{{ (Object.keys(currentUser).length !=0 ?  currentUser.name : '') }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="card_present" cols="12" sm="12">
                        <div > {{ 'Need to change payment method?' | translate }} <v-btn color="primary darken-1" text @click="gotoProfile()">{{ 'Go to profile' | translate }}</v-btn></div>
                      </v-col>
                      <v-col v-if="!card_present" cols="12" sm="12">
                        <div :class=" no_card_notification ? 'no_card_notification': ''"> {{ 'You dont seem to have a card added to your profile' | translate }} 
                        <v-btn color="primary darken-1" text @click="gotoProfile()">{{ 'Go to profile' | translate }}</v-btn>
                        </div>
                      </v-col>
                    </v-row>
                
              </v-col>
              <v-col cols="12" sm="5">
                <v-card max-width="800">
                  <v-card-title class="pb-0">{{'Order Summary' | translate}}</v-card-title>
                  <v-container>
                    <v-row justify="space-between">
                      <v-card-subtitle class="title py-1 pl-3">{{ 'Tutor Product' | translate }}</v-card-subtitle>
                      <v-card-subtitle class="title py-1 pr-3">{{'Subtotal' | translate}}</v-card-subtitle>
                    </v-row>
                    <v-row justify="space-between">
                      <v-card-subtitle> {{this.tutor_product_name}} </v-card-subtitle>
                      <v-card-subtitle>{{ this.product_amount }}</v-card-subtitle>
                    </v-row>
                    
                    <v-divider></v-divider>

                    <v-row justify="space-between">
                      <v-card-subtitle>
                        <v-text-field
                          :label="'Coupon Code' | translate"
                          v-model="coupon_id"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                        <div v-if="coupon_valid!=null && !coupon_valid" class="error--text"><v-icon class="theme--dark error--text" small v-if="coupon_message">mdi-alert</v-icon><strong> {{coupon_message|translate}} </strong></div>
                        <div v-if="coupon_valid" class="success--text"><v-icon class="theme--dark success--text" small>mdi-checkbox-marked-circle</v-icon><strong>{{coupon_message|translate}}</strong></div>
                      </v-card-subtitle>
                      <v-card-subtitle>
                        <v-btn
                          rounded
                          small
                          @click="applyCoupon()"
                        >{{'Apply'| translate}}</v-btn>
                        <v-btn
                          rounded
                          small
                          @click="clearCoupon()"
                        >{{'Clear'| translate}}</v-btn>
                      </v-card-subtitle>
                    </v-row>
                    
                    <v-divider></v-divider>

                    <v-row justify="space-between">
                      <v-card-subtitle class="title py-1 pr-3">{{'Total' | translate}}</v-card-subtitle>
                      <v-card-subtitle class="title py-1 pr-3">{{this.product_amount}}{{this.currency}}</v-card-subtitle>
                    </v-row>

                    <v-row justify="center" no-gutters>
                        <v-checkbox v-model="agree_terms" light>
                        <template slot="label">
                          {{'I agree' | translate}} <a @click.stop href="/pages/terms" target="_blank">{{'terms'| translate}}</a>
                        </template>
                      </v-checkbox>
                        <v-card-actions>
                          <v-container>
                            <v-row dense no-gutters>
                             <v-col>
                                <v-btn color="primary darken-1" text @click="bookingDialog = false">{{ 'Cancel' | translate }}</v-btn>
                             </v-col>
                             <v-col>
                                <v-btn color="green darken-1" text @click="subscribe()" v-if="agree_terms && (coupon_valid || (coupon_valid==null))">{{ 'Subscribe' | translate }}</v-btn>
                             </v-col>
                             <v-col>
                                <v-btn color="primary darken-1" text @click="bookingDialog = false; tutorDialog = true;">{{ 'Pick another' | translate }}</v-btn>
                             </v-col>
                            </v-row>
                          </v-container>
                        </v-card-actions>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
      </v-card>
    </v-dialog> 

      <v-dialog v-if="!loadingdata" v-model="messageDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{ 'Booking Complete' | translate }}</v-card-title>
        <v-spacer></v-spacer>
        <v-card-subtitle>{{ "Please check you email for further details."| translate }}</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="messageDialog = false; tutorDialog= true ">{{ 'Book Again'| translate }}</v-btn>
          <v-btn color="primary darken-1" text @click="messageDialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay> 

    

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

import {
  FETCH_TUTOR_PRODUCTS,
  TUTOR_PRODUCT_SUBSCRIBE,
  VALIDATE_TUTOR_COUPON,
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";

export default {
    name: 'Modal',
    props:{
        buttonName: String,
    },
    data: function() {
        return {
            storage_url: '',
            tutorDialog: false,
            bookingDialog:false,
            primary_color: 'rgba(0, 0, 0, 0.38)',
            tutorProduct:{},
            no_card_notification:false,
            default_product_amount: null,
            coupon_id: null,
            card_present:false,
            coupon_amount: null,
            coupon_valid: null,
            coupon_message:null,
            agree_terms: false,
            tutor_product_id:'',
            product_amount: 0,
            currency: null,
            tutor_product_name: '',
            isLoading: false,
            messageDialog:false,
        }
    },
    computed: {
        ...mapGetters(["currentUser","loadingdata","tutorproducts","stripeallcards"]),    
    },
    created(){
        this.storage_url  = process.env.VUE_APP_STORAGE_URL
        let company_meta  = JSON.parse(this.currentUser.company.company_meta)
        this.primary_color  = company_meta.primary_color
    },
    methods: {
        async openTutorListModal() {
                await store.dispatch(FETCH_TUTOR_PRODUCTS, '').then(resp => {
                if (resp.success) {
                    store.commit(SET_LOADING, false);
                    store.commit(SET_ROUTER_ENTER, false)
                }
                });
            this.tutorDialog = true;
        },
        openbooking(tutorProduct){
            this.tutorProduct = tutorProduct
            this.tutor_product_id= tutorProduct.tutor_product_id
            this.tutor_product_name= tutorProduct.tutor_product_name
            this.product_amount= tutorProduct.plan.product_amount
            this.default_product_amount= tutorProduct.plan.product_amount
            this.currency= tutorProduct.plan.currency
          if (this.currentUser.company.account_type == "on-demand") {
            this.coupon_amount = ((tutorProduct.plan.coupon_amount !== null)?(tutorProduct.plan.coupon_amount):null)
            this.tutorDialog=false
            this.bookingDialog=true
            //Clear all previous validations
            this.clearCoupon()
            this.no_card_notification = false
            
            if (this.stripeallcards.length !== 0) {
              this.card_present = true;
            }
          }
          else if (this.currentUser.company.account_type == "full-version") {
            this.isLoading = true
            this.subscribe();
            
          }
          
        },
        gotoProfile(){
          this.bookingDialog = false;
          this.$router.push("/profile");
        },
        clearCoupon(){
          this.coupon_id = null;
          this.coupon_valid = null;
          this.coupon_message = null
          this.product_amount = this.default_product_amount;
        },
        async applyCoupon(){
          store.commit(SET_LOADING, false)
          var params = 'item_id='+this.tutor_product_id;
          if(this.coupon_id){
            params = 'item_id='+this.tutor_product_id+'&coupon_code='+this.coupon_id;
          }

          await this.$store.dispatch(VALIDATE_TUTOR_COUPON,params).then(resp => {
            if (resp !=undefined && resp.success) {
                this.coupon_valid = true
                this.product_amount = this.coupon_amount
                this.coupon_message = resp.message
                this.isLoading = false
            }
            else{
              this.product_amount = this.default_product_amount
              this.coupon_valid = false
              this.coupon_message = resp.response.data.message
              this.isLoading = false
            }
          });
        },
        async subscribe() {
          this.coupon_valid = null;

          if (this.currentUser.company.account_type == "on-demand") {
            this.dialog = true;

            //first we check if any coupon is present and if present is valid
            if(this.coupon_id){
              await this.applyCoupon()
            }
          //You can subscribe if
          // coupon is valid and product amount is zero
          // coupon is valid and product_amount is not zero and card is present
          // no coupon and card is present
            var params ={
                id:this.tutor_product_id,
            }
            if((this.coupon_valid) && (this.product_amount == 0)){
              params['coupon_code']= this.coupon_id
              this.all_valid = true
            } else if(this.coupon_valid && (this.product_amount != 0) && !this.card_present){
              this.no_card_notification = true
              this.all_valid = false
            } 
            else if(!this.coupon_valid && this.coupon_id){
                  this.coupon_valid = false
                  this.all_valid = false
            }
            else if( (this.product_amount != 0) && !this.card_present){
              this.no_card_notification = true
              this.all_valid = false
            }
            else{
              //check when card is present logic
              this.all_valid = true
            }  

            if(this.all_valid){
              this.isLoading = true
              this.dialog = false;
              await this.$store.dispatch(TUTOR_PRODUCT_SUBSCRIBE, params).then(resp => {
                if (resp.success) {
                    this.dialog = false;
                    this.$store.dispatch(FETCH_TUTOR_PRODUCTS, '').then(resp => {
                      if (resp.success) {
                        this.coupon_valid = false
                        this.coupon_id = null
                        this.agree_terms = false
                        store.commit(SET_LOADING, false);
                        this.isLoading = false
                        this.bookingDialog = false;
                        this.messageDialog=true
                      }
                      else{
                        this.isLoading = false
                        store.commit(SET_LOADING, false);
                      }
                    });              
                }
              });
            }
            else{
                  this.product_amount = this.default_product_amount
                  this.isLoading = false
            }
          
          }
          else if (this.currentUser.company.account_type == "full-version") {
            this.isLoading = true
            let params={
              id:this.tutor_product_id,
            }
            this.$store.dispatch(TUTOR_PRODUCT_SUBSCRIBE, params).then(resp => {
              if (resp != undefined && resp.success) {
                  this.$store.dispatch(FETCH_TUTOR_PRODUCTS, '').then(resp => {
                    if (resp.success) {
                      this.isLoading = false
                      store.commit(SET_LOADING, false);
                        this.isLoading = false
                        this.tutorDialog = false;
                        this.messageDialog=true
                    }
                  }); 
              }
              else{
                this.isLoading = false
                store.commit(SET_LOADING, false);
              }
            });
          }
        },
    },
  };
</script>

<style scoped>
.tutor-image{
  max-width:500px;
  max-height:300px;
  width: 100px;
  border-radius: 50%;
}
.title{
    font-weight: 400;
}
.sub-title{
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.0071428571em;
}
.tutor-container{
    background-color: #fafafa !important;
}
.tutor-product-box{
  padding: 15px;
}
.tutor-element{
    padding: 10px;
}
.image-box{
    padding-left: 20px;
}
.no_card_notification{
  color: red;
}
.subscribed-button{
  cursor: default !important;
}
.book-button{
  background-color: white !important;
}
</style>